module.exports = __webpack_public_path__ + "static/media/shoe_05.fbb085dc.jpg";